import * as React from "react";
const SvgFiRrBagSeedling = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bag-seedling_svg__a)">
      <path
        fill="#062147"
        d="M22.77 21.106 22 19.295V4.705l.763-1.784a1.97 1.97 0 0 0-.04-1.929A1.97 1.97 0 0 0 21.002 0H2.999c-.72 0-1.362.371-1.723.992a1.97 1.97 0 0 0-.04 1.929L2 4.705v14.591l-.771 1.811a1.98 1.98 0 0 0 .043 1.929 1.97 1.97 0 0 0 1.72.989h18.015c.717 0 1.359-.37 1.72-.989.35-.601.365-1.318.044-1.93M20.996 1.987c-.02.033-.867 2.012-.867 2.012H3.873s-.855-1.967-.874-2l17.995-.012M20 5.999v12H4V6h16zM3 22.035c.019-.033.873-2.035.873-2.035h16.252s.862 1.991.88 2.024zM11 13.951V15a1 1 0 1 0 2 0v-1.054c1.57-.179 4.495-1.029 4.992-4.832.083-.635-.482-1.198-1.116-1.103-3.513.527-4.546 3.456-4.874 4.981h-.004c-.325-1.528-1.385-4.453-4.874-4.981-.632-.096-1.196.465-1.117 1.099.478 3.81 3.415 4.661 4.992 4.841"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bag-seedling_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBagSeedling;
